import { ComponentBase } from '../component/component.base';
import { IComponentSidebarBase } from './component-sidebar.interface';

export abstract class ComponentSidebarBase extends ComponentBase implements IComponentSidebarBase {
    
}